import { Goal } from "./goal";

export class GoalExtensions {
    public constructor(private goal: Goal) { }

    public get isComplete() {
        return !!this.goal.name && this.goal.measurements.length > 1 && this.goal.measurements.every((i) => !i.entityAspect.hasValidationErrors);
    }
}
